import React from 'react'
import './Main.less'
import { Route, Switch, Redirect } from 'react-router-dom'
import { mainRoutes } from '../routes'
import { Icon } from 'antd'
class Person extends React.Component {
  constructor(props) {
    super()
    this.state = {
      title: ''
    }
  }
  setTitle = (title) => {
    this.setState({
      title: title
    })
  }
  backHandler = () => {
    this.props.history.goBack()
  }
  render() {
    return (
      <div className="main">
        {/* <div className='nav flex align-center'>
          <div className='back-icon' onClick={this.backHandler}><Icon type="left" /></div>
          <div className='title flex-auto'>{this.state.title}</div>
          <div className='more-icon'><Icon type="more" rotate={90}/></div>
        </div> */}
        <div className='content'>
        <Switch>
          {
            mainRoutes.map(item => {
              return (
                <Route path={item.pathname} key={item.pathname} render={(routerProps) => {
                  return <item.component {...item} {...routerProps} setTitle={this.setTitle}/>
                }}></Route>
              )
            })
          }
        </Switch>
        </div>
      </div>
    )
  }
}
export default Person
